import { createApp } from "vue";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import { ThemePreset } from "./theme.js";
import { getCurrentThemeName, getSelectedTheme } from "./config/theme.js";

// PrimeVue Components
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Card from "primevue/card";
import Menu from "primevue/menu";
import Avatar from "primevue/avatar";
import Badge from "primevue/badge";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ProgressBar from "primevue/progressbar";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import Checkbox from "primevue/checkbox";
import RadioButton from "primevue/radiobutton";
import InputSwitch from "primevue/inputswitch";
import Panel from "primevue/panel";
import Toolbar from "primevue/toolbar";
import ConfirmDialog from "primevue/confirmdialog";
import Dialog from "primevue/dialog";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import Tooltip from "primevue/tooltip";
import Password from "primevue/password";
import Textarea from "primevue/textarea";
import MultiSelect from "primevue/multiselect";
import ToggleSwitch from "primevue/toggleswitch";
import Tag from "primevue/tag";
import Sidebar from "primevue/sidebar";
import OverlayPanel from "primevue/overlaypanel";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Toast from "primevue/toast";

// PrimeVue Services
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";

import App from "./App.vue";
import router from "./router";
import "./style.css";
import "./assets/styles/globals.css";
import "primeicons/primeicons.css";

if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
	document.title = `DEV | ${document.title}`;
}

const app = createApp(App);

// Apply PrimeVue with dynamic theme preset
// Theme is loaded from ./theme.js which gets generated during CLI setup
// Current theme: ${getCurrentThemeName()}
app.use(PrimeVue, {
	theme: {
		preset: ThemePreset,
		options: {
			prefix: "p",
			darkModeSelector: ".dark-mode",
			cssLayer: false,
		},
	},
});

// Register PrimeVue components globally
app.component("Button", Button);
app.component("InputText", InputText);
app.component("Card", Card);
app.component("Menu", Menu);
app.component("Avatar", Avatar);
app.component("Badge", Badge);
app.component("DataTable", DataTable);
app.component("Column", Column);
app.component("ProgressBar", ProgressBar);
app.component("Dropdown", Dropdown);
app.component("Calendar", Calendar);
app.component("Checkbox", Checkbox);
app.component("RadioButton", RadioButton);
app.component("InputSwitch", InputSwitch);
app.component("Panel", Panel);
app.component("Toolbar", Toolbar);
app.component("ConfirmDialog", ConfirmDialog);
app.component("Dialog", Dialog);
app.component("IconField", IconField);
app.component("InputIcon", InputIcon);
app.component("Password", Password);
app.component("Textarea", Textarea);
app.component("MultiSelect", MultiSelect);
app.component("ToggleSwitch", ToggleSwitch);
app.component("Tag", Tag);
app.component("Sidebar", Sidebar);
app.component("OverlayPanel", OverlayPanel);
app.component("TabView", TabView);
app.component("TabPanel", TabPanel);
app.component("Toast", Toast);

app.use(createPinia());
app.use(router);
app.use(ToastService);
app.use(ConfirmationService);
app.directive("tooltip", Tooltip);

app.mount("#app");
